/**
 * Utility functions for formatting and displaying learning time
 */

export const formatLearningTime = (minutes: number, type: 'lesson' | 'exercise' | 'general' = 'general'): string => {
  if (minutes === 0) {
    switch (type) {
      case 'lesson': return "לא נלמד עדיין";
      case 'exercise': return "לא נתרגל עדיין";
      default: return "לא נלמד עדיין";
    }
  }
  
  if (minutes < 60) {
    return `${minutes} דק'`;
  }
  
  const hours = Math.floor(minutes / 60);
  const remainingMinutes = minutes % 60;
  return `${hours}:${remainingMinutes.toString().padStart(2, '0')} שעות`;
};

// DEBUG_LEARNING_MINUTES_GENERAL: General debug helper for learning minutes data
export const debugLearningMinutes = (
  data: {
    id?: number;
    name?: string;
    learningMinutes?: number;
    totalUnits?: number;
    completedUnits?: number;
  },
  context: string = "Feature"
) => {
  console.group(`📊 ${context} Learning Minutes Debug`);
  console.log("🎯 Data:", {
    id: data.id,
    name: data.name,
    learningMinutes: data.learningMinutes,
    totalUnits: data.totalUnits,
    completedUnits: data.completedUnits,
    formattedTime: formatLearningTime(data.learningMinutes || 0)
  });
  
  if ((data.learningMinutes || 0) === 0) {
    console.warn(`⚠️ ${context} learning minutes is 0 - possible issues:`);
    console.log("- No units completed yet");
    console.log("- Backend not returning learning minutes field");
    console.log("- Unit completion not tracking time properly");
    console.log("- Session status issues");
  } else {
    console.log(`✅ ${data.learningMinutes} minutes tracked successfully`);
  }
  
  console.groupEnd();
};

export const shouldHighlightLearningTime = (minutes: number): boolean => {
  return minutes > 0;
};

// DEBUG_ENHANCED_LEARNING_MINUTES: Specific debug helper for enhanced learning minutes feature
export const debugEnhancedLearningMinutes = (context: string = "Feature") => {
  console.group(`🚀 Enhanced Learning Minutes - ${context}`);
  console.log("📋 New Calculation:");
  console.log("   learningMinutes = (CompletedLearningSeconds + WatchActivitySeconds) / 60");
  console.log("📊 What's Being Tracked:");
  console.log("   ✅ Unit completions (existing)");
  console.log("   ✅ Incomplete study sessions (NEW!)");
  console.log("   ✅ Navigation between units (NEW!)");
  console.log("   ✅ Browser close/refresh (NEW!)");
  console.log("   ✅ Tab switching (NEW!)");
  console.log("🔍 Watch for:");
  console.log("   📤 'Sending Watch Activity' messages");
  console.log("   🎯 'Study Session Started/Ended' messages");
  console.log("   ✅ Increased learning minutes even without completion");
  console.groupEnd();
}; 